<div>
	@if (loading()) {
		<nz-spin nzSimple nzSize="large"></nz-spin>
	}

	@if (!loading() && allClientSections().length > 0) {
		<nz-select
			[nzMaxTagCount]="3"
			[nzMaxTagPlaceholder]="tagPlaceHolder"
			nzMode="multiple"
			nzPlaceHolder="Please select"
			[ngModel]="selectedSectionIds()"
			(ngModelChange)="onSelectionChange($event)"
			[ngModelOptions]="{ standalone: true }"
		>
			@for (clientSection of allClientSections(); track clientSection.client.uuid) {
				@for (section of clientSection.sections; track section.uuid) {
					<nz-option
						[nzLabel]="
							(clientSection.client.active_text?.name || clientSection.client.subdomain) +
							' - ' +
							section.name +
							' - ' +
							section.language
						"
						[nzValue]="section.uuid"
					></nz-option>
				}
			}
		</nz-select>
		<ng-template #tagPlaceHolder let-selectedList>and {{ selectedList.length }} more selected</ng-template>
	}
</div>
